<script>
import headBox from "@/components/head.vue"
import footBox from "@/components/foot.vue"
import {getText} from "@/utils/text";
import text from "../utils/text";

export default {
  computed: {
    text() {
      return text
    }
  },
  data() {
    return {
      showMenu: false
    }
  },
  components: {headBox, footBox},
  mounted() {
    document.addEventListener('DOMContentLoaded', function () {

      // 获取所有FAQ按钮
      const faqButtons = document.querySelectorAll('.disclosure-button');
      // 遍历每个按钮，添加点击事件监听器
      faqButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          // 获取对应的FAQ内容
          const faqContent = this.nextElementSibling;

          // 切换FAQ内容的显示和隐藏
          // classList.toggle('hidden')  表示增或者移除一个类选择器
          // faqContent.classList.toggle('hidden');

          // 切换FAQ内容的显示和隐藏
          if (faqContent.classList.contains('disclosure-inactive')) {
            faqContent.classList.replace('disclosure-inactive', 'disclosure-active');
          } else {
            faqContent.classList.replace('disclosure-active', 'disclosure-inactive');
          }

          // 切换箭头的方向
          // 查询当天点击的孩子元素，可以是一群
          const arrow = this.querySelector('img');
          arrow.classList.toggle('rotate-180');
        });
      });
    });
  },
  methods: {
    getViewText(key) {
      return getText(key)
    }
  }
}
</script>


<template>
  <div>
    <headBox/>

    <section class="slider1" style="margin-top:64px">
      <VueSlickCarousel :autoplay="true" :autoplaySpeed="2000" :arrows="false" :dots="true" :speed="1000">
        <div class="img_box slider1Banner1">
          <img draggable="false" src="../assets/img/banner/banner1.png"/>
        </div>
        <div class="img_box slider1Banner2">
          <img draggable="false" src="../assets/img/banner/banner2.png"/>
        </div>
        <div class="img_box slider1Banner3">
          <img draggable="false" src="../assets/img/banner/banner3.png"/>
        </div>
        <div class="img_box slider1Banner4">
          <img draggable="false" src="../assets/img/banner/banner4.png"/>
        </div>
        <div class="img_box slider1Banner5">
          <img draggable="false" src="../assets/img/banner/banner5.png"/>
        </div>
      </VueSlickCarousel>
    </section>

    <!-- 卡片 -->
    <section id="rummyCard" class="rummyCard">
      <div class="content">
        <div class="myContent">
          <div class="itemsCenter">
            <img src="../assets/img/sanjiaoxing.png" alt="rummy">
          </div>
          <div class="home-title">
            <div>
              <span>{{ getViewText('card_tit_1')[0] }}</span>
              <label>{{ getViewText('card_tit_1').substring(1, getViewText('card_tit_1').length) }}</label>
            </div>
          </div>
          <div class="img">
            <div class="imgCard itemsCenter items-center">
              <div>
                <img class="icon" src="../assets/img/poker.png">
                <h3 style="color: #FFA400;font-size: 20px;font-weight: 600;">{{ getViewText("rummy") }}</h3>
                <div style="margin: 10px 0;font-size: 14px;color: #fff">{{ getViewText("card_label_1") }}</div>
                <button>
                  <a href="https://www.davisandgrill.com/apk/DavisandGrillRummy.apk">{{ getViewText('download') }}</a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="accomplishmentCares"
             class="accomplishment-cares sm:accomplishment-cares-sm md:accomplishment-cares-md lg:accomplishment-cares-lg">
      <div class="flex justify-center ">
        <div class="itemsCenter">
          <div class="derection">
            <img src="../assets/img/sanjiaoxing.png">
          </div>
          <div class="home-title">
            <div>
              <span>{{ getViewText('card_tit_2')[0] }}</span>
              <label>{{ getViewText('card_tit_2').substring(1, getViewText('card_tit_2').length) }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="accomplishment md:accomplishment-md">
        <div class="md:max-w-[720px] lg:max-w-[920px] mx-auto">
          <div class="grid grid-cols-3 col-span-5 gap-3">
            <div class="justify-self-center">
              <div class="flex flex-col justify-center ">
                <img class="h-8 w-8 md:h-12 md:w-12"
                     src="../assets/img/accomplishmentCares/icon1.png"
                     alt="Rummy" title="Rummy"
                     style="align-self:center" loading="lazy">
                <img src="../assets/img/accomplishmentCares/explain1.png">
                <!-- <div class="big text-center sm:text-size-1 md:text-size-3 lg:text-size-3">7 Crore +</div>
                <div class="text text-center sm:text-size-1 md:text-size-3 lg:text-size-3">Players</div> -->
              </div>
            </div>
            <div class="justify-self-center">
              <div class="icon flex flex-col justify-center ">
                <img class="h-8 w-8 md:h-12 md:w-12"
                     src="../assets/img/accomplishmentCares/icon2.png"
                     alt="Rummy" title="Rummy"
                     style="align-self:center" loading="lazy">
                <img src="../assets/img/accomplishmentCares/explain2.png">
                <!-- <div class="big text-center sm:text-size-1 md:text-size-3 lg:text-size-3">7 Crore +</div>
                <div class="text text-center sm:text-size-1 md:text-size-3 lg:text-size-3">Players</div> -->
              </div>
            </div>
            <div class="justify-self-center">
              <div class="icon flex flex-col justify-center ">
                <img class="h-8 w-8 md:h-12 md:w-12"
                     src="../assets/img/accomplishmentCares/icon3.png"
                     alt="Rummy" title="Rummy"
                     style="align-self:center" loading="lazy">
                <img src="../assets/img/accomplishmentCares/explain3.png">
                <!-- <div class="text text-center sm:text-size-1 md:text-size-3 lg:text-size-3">Trusted &amp;
                  Secure
                </div> -->
              </div>
            </div>
            <div class="justify-self-center">
              <div class="icon flex flex-col justify-center ">
                <img class="h-8 w-8 md:h-12 md:w-12"
                     src="../assets/img/accomplishmentCares/icon4.png"
                     alt="Rummy" title="Rummy"
                     style="align-self:center" loading="lazy">
                <img src="../assets/img/accomplishmentCares/explain4.png">
                <!-- <div class="big text-center sm:text-size-1 md:text-size-3 lg:text-size-3">7 Crore +</div>
                <div class="text text-center sm:text-size-1 md:text-size-3 lg:text-size-3">Players</div> -->
              </div>
            </div>
            <div class="justify-self-center">
              <div class="icon flex flex-col justify-center ">
                <img class="h-8 w-8 md:h-12 md:w-12"
                     src="../assets/img/accomplishmentCares/icon5.png"
                     alt="Rummy" title="Rummy"
                     style="align-self:center" loading="lazy">
                <img src="../assets/img/accomplishmentCares/explain5.png">
                <!-- <div class="big text-center sm:text-size-1 md:text-size-3 lg:text-size-3">7 Crore +</div>
                <div class="text text-center sm:text-size-1 md:text-size-3 lg:text-size-3">Players</div> -->
              </div>
            </div>
            <div class="justify-self-center">
              <div class="icon flex flex-col justify-center ">
                <img class="h-8 w-8 md:h-12 md:w-12"
                     src="../assets/img/accomplishmentCares/icon6.png"
                     alt="Rummy" title="Rummy"
                     style="align-self:center" loading="lazy">
                <img src="../assets/img/accomplishmentCares/explain6.png">
                <!-- <div class="big text-center sm:text-size-1 md:text-size-3 lg:text-size-3">7 Crore +</div>
                <div class="text text-center sm:text-size-1 md:text-size-3 lg:text-size-3">Players</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="chip">
      <div>
        <img src="../assets/img/chip.png" alt="">
      </div>
    </section>

    <section id="gameIntro" class="game-intro sm:game-intro-sm md:game-intro-md lg:game-intro-lg ">
      <div class="container">
        <div class="itemsCenter">
          <img src="../assets/img/sanjiaoxing.png">
        </div>
        <div class="home-title">
          <div>
            <span>{{ getViewText('card_tit_3')[0] }}</span>
            <label>{{ getViewText('card_tit_3').substring(1, getViewText('card_tit_3').length) }}</label>
          </div>
        </div>
        <div class="clearfix md:max-w-[720px] lg:max-w-[920px] mx-auto">
          <el-row :gutter="40">
            <el-col :sm="10">
              <div style="width: 100%;margin-bottom: 20px">
                <img src="../assets/img/gameIntro/logo.png">
              </div>
            </el-col>
            <el-col :sm="14">
              <div class="description sm:text-size-2 md:text-size-2 lg:text-size-3 md:w-full"
                   style="padding: 0;width: 100%">
                <div class="textgame">
                  {{getViewText('text_1')}}
                </div>
                <div class="readmore">
                  <router-link :to="{ name: 'gameIntroduction' }">{{ getViewText('read_more')}}</router-link>
                </div>
              </div>
            </el-col>
          </el-row>


        </div>
      </div>
    </section>

    <section id="gamerSpeak" class="gamer-speak w-full">
      <div class="">
        <div class="itemsCenter">
          <img src="../assets/img/sanjiaoxing.png">
        </div>
        <div class="home-title">
          <div>
            <span>{{ getViewText('card_tit_4')[0] }}</span>
            <label>{{ getViewText('card_tit_4').substring(1, getViewText('card_tit_4').length) }}</label>
          </div>
        </div>
      </div>
      <div id="ourGamerSay"
           class="our-gamer-say sm:our-gamer-say-sm md:our-gamer-say-md lg:our-gamer-say-lg xl:our-gamer-say-xl">
        <div class="alice-carousel">
          <div class="slider3">
            <el-row :gutter="10">
              <VueSlickCarousel :autoplay="true" :autoplaySpeed="3000" :vertical="$store.state.isPhone" :arrows="false"
                                :dots="true"
                                :slidesToShow="3"
                                :slidesToScroll="3">
                <el-col :sm="8">
                  <div class="img_box">
                    <img draggable="false" src="../assets/img/people/1.png"/>
                    <div class="px-2">
                      <div class="gamecard-title">{{getViewText('evaluate_t_1')}}</div>
                      <div class="gamecard-description">{{getViewText('evaluate_c_1')}}
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :sm="8">
                  <div class="img_box">
                    <img draggable="false" src="../assets/img/people/2.png"/>
                    <div class="px-2">
                      <div class="gamecard-title">{{ getViewText('evaluate_t_2') }}</div>
                      <div class="gamecard-description">{{
                          getViewText('evaluate_c_2')
                        }}
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :sm="8">
                  <div class="img_box">
                    <img draggable="false" src="../assets/img/people/3.png"/>
                    <div class="px-2">
                      <div class="gamecard-title">{{getViewText('evaluate_t_3')}}</div>
                      <div class="gamecard-description">{{ getViewText('evaluate_c_3') }}
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :sm="8">
                  <div class="img_box">
                    <img draggable="false" src="../assets/img/people/4.png"/>
                    <div class="px-2">
                      <div class="gamecard-title">{{getViewText('evaluate_t_4')}}</div>
                      <div class="gamecard-description">
                        {{getViewText('evaluate_c_4')}}
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :sm="8">
                  <div class="img_box">
                    <img draggable="false" src="../assets/img/people/5.png"/>
                    <div class="px-2">
                      <div class="gamecard-title">{{getViewText('evaluate_t_5')}}</div>
                      <div class="gamecard-description">
                        {{getViewText('evaluate_c_5')}}
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :sm="8">
                  <div class="img_box">
                    <img draggable="false" src="../assets/img/people/6.png"/>
                    <div class="px-2">
                      <div class="gamecard-title">{{ getViewText('evaluate_t_6')}}</div>
                      <div class="gamecard-description">
                        {{getViewText('evaluate_c_6')}}
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :sm="8">
                  <div class="img_box">
                    <img draggable="false" src="../assets/img/people/7.png"/>
                    <div class="px-2">
                      <div class="gamecard-title">{{getViewText('evaluate_t_7')}}</div>
                      <div class="gamecard-description">
                        {{getViewText('evaluate_c_7')}}
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :sm="8">
                  <div class="img_box">
                    <img draggable="false" src="../assets/img/people/8.png"/>
                    <div class="px-2">
                      <div class="gamecard-title">{{getViewText('evaluate_t_8')}}</div>
                      <div class="gamecard-description">
                        {{getViewText('evaluate_c_8')}}
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :sm="8">
                  <div class="img_box">
                    <img draggable="false" src="../assets/img/people/9.png"/>
                    <div class="px-2">
                      <div class="gamecard-title">{{getViewText('evaluate_t_9')}}</div>
                      <div class="gamecard-description">
                        {{getViewText('evaluate_c_9')}}
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :sm="8">
                  <div class="img_box">
                    <img draggable="false" src="../assets/img/people/10.png"/>
                    <div class="px-2">
                      <div class="gamecard-title">{{getViewText('evaluate_t_10')}}</div>
                      <div class="gamecard-description">
                        {{getViewText('evaluate_c_10')}}
                      </div>
                    </div>
                  </div>
                </el-col>
              </VueSlickCarousel>
            </el-row>
          </div>
        </div>
      </div>
      <!-- <div class="view-all-btn-container text-center pt-3 flex justify-center">
        <a class="btn-bg-view btn-radius" href="https://www.a23.com/rummy/rummy-champions.html">
          View All
        </a>
      </div> -->
    </section>

    <section id="sectionAbout">
      <div class="section-about sm:section-about-sm md:section-about-md lg:section-about-lg xl:section-about-xl">
        <div class="panel-heading relative mx-[15px]">
          <!-- <div class="panel-title sm:heading-size-1-sm md:heading-size-1-md lg:heading-size-1-lg">
            <button id="aboutA23Games" class="accordion-toggle-collapse">About A23</button>
          </div> -->

          <div class="itemsCenter">
            <img src="../assets/img/sanjiaoxing.png">
          </div>
          <div class="home-title">
            <div>
              <span>{{ getViewText('card_tit_5')[0] }}</span>
              <label>{{ getViewText('card_tit_5').substring(1, getViewText('card_tit_5').length) }}</label>
            </div>
          </div>
        </div>
        <div class="false">
          <div class="panel-body">
            <div class="my-container">
              <el-row :gutter="10">
                <el-col :sm="12" class="mb-3">
                  <div class="ourCompany px-[15px]">
                    <div class="about_h3">{{ getViewText('our_company') }}</div>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">
                      {{getViewText('text_2')}}
                    </p>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">
                      {{getViewText('text_3')}}
                    </p>
                  </div>
                </el-col>
                <el-col :sm="12">
                  <div class="OurTeam px-[15px]">
                    <div class="about_h3">{{ getViewText('our_team')}}</div>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">
                      {{getViewText('text_4')}}
                    </p>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">
                      {{getViewText('text_5')}}
                    </p>
                  </div>
                </el-col>
              </el-row>


            </div>
          </div>

          <!-- 这里应该是使用的js 展开 -->
          <div class="px-[15px] false">
            <div class="text-center" style="margin:15px 0">
              <!-- <button style="font-size:16px;width:180px;height:auto;margin:auto;padding:5px 20px;border:2px solid #032146;border-radius:30px;text-decoration:none;cursor:pointer"
                      class="moreless-button c-white">Read more
              </button> -->
            </div>
            <div class="moretext inActiveToggle">
              <div>
                <h2 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                  Who we are
                </h2>
                <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">At A23, we are a leading
                  destination for online gaming in India. We are exclusively managed and owned by Head
                  Digital Works Private Limited. As part of its efforts to improve the online gaming
                  scene in India, A23 has built a platform that will bring together a large community
                  of skilled gamers from all over the country.
                </p>
                <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">A23, an online gaming platform,
                  has almost 20 years of experience, and our vision is to be the top platform for
                  gamers. Our focus is to keep things fun and exciting, by constantly adding new
                  features and games. But fun isn't the only thing we care about, we prioritise
                  responsible gaming and create a safe environment for all players. We also have an
                  age restriction in place, to ensure that all players are of legal age and capable of
                  being responsible gamers.
                </p>
                <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">Our team of experts use advanced
                  technology to ensure smooth gameplay and lag-free experience. Whether you are a
                  seasoned player or new to the platform, our aim is to provide the best online gaming
                  experience. Download the A23 app to know more about our games and gaming policies.
                  We are sure you will find that will interest you.
                </p>
              </div>
              <div>
                <h2 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                  Key features of online gaming tournaments on A23
                </h2>
                <ul
                  class="list-disc pl-[15px] mb-4 text-[0.75rem] md:text-[14px] sm:text-size-2 md:text-size-2 lg:text-size-3">
                  <li>
                    <h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                      Experience responsible gaming:
                    </h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">Real cash games are fun,
                      but only with responsible gaming. We guarantee a safe and fun gaming
                      experience for all of our players. Like with every game, there can be
                      potential risks to playing online cash games.
                    </p>
                  </li>
                  <li>
                    <h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                      A23 Cares
                    </h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">The A23 Cares feature is
                      all about creating a balanced and enjoyable gaming experience for everyone.
                      This feature helps you plan your gaming time and take breaks when required.
                      By keeping healthy gaming habits, A23 Cares ensures that all the players
                      focus on the excitement, making it fun for everyone.
                    </p>
                  </li>
                  <li>
                    <h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                      Rummy School
                    </h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">A23 Rummy School helps
                      new users learn how to play the game and become better players. The rules
                      are explained in a simple and clear manner so that players of all levels can
                      understand the rules of the games and begin playing on the A23 app.
                    </p>
                  </li>
                  <li>
                    <h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                      Trust
                    </h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">Over the last 18 years,
                      the A23 online platform has built trust amongst 7 Cr+ players. Through our
                      fair play measures no bots can access the game, only genuine players
                      can.
                    </p>
                  </li>
                  <li>
                    <h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                      Freeroll Tournaments
                    </h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">Our
                      <a href="https://www.a23.com/tourneyInfo.html">daily free tournaments</a>
                      give you a chance to win your share of a ₹45 lakhs pool. So, what are you
                      waiting for? Download the A23 app and get playing.
                    </p>
                  </li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">VIP
                    Hosts:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">You will be provided a
                      dedicated VIP host, who will create personalised games only for you. Your
                      invitation depends on the number of points/merits earned by playing various
                      A23. Keep playing to become a VIP. Being a part of the VIP club, you will be
                      offered benefits such as welcome bonuses, personalised offers, special
                      occasion gifts, surprise bonus, priority service, and VIP-only
                      tournaments.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                    Generous Welcome Bonus:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">We offer a generous <a
                      href="https://www.a23.com/a23-welcome-bonus.html">welcome bonus</a> to
                      get you started and help you win your share of the prize pool.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                    Responsive customer support:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">Our responsive customer
                      support service ensures assistance during games and autoplay to ensure you
                      are not far from the table.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Set
                    limits:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">Limit your time and
                      money spent on our gaming app. A23's gaming control tools help you balance
                      gaming with other life activities. You can control how you play the game;
                      you can set deposit limits, track your gaming history, and even schedule
                      breaks to ensure a balanced gaming experience.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                    Certifications:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">With multiple
                      certifications and security measures in place, such as Digicert, iTech Labs
                      certification, and an age limit, we control the happenings on the platform
                      to keep it safe and sure. The A23 platform is 100% safe and secure.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Money
                    Back:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">If your KYC documents
                      are in place, then you can avail of the instant withdrawal facility provided
                      by the platform. It is essential to keep the documents in place for a
                      seamless experience.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">The
                    Beginning:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">We started as a web
                      portal in 2006 with the idea of bringing online games to a wider audience
                      and our little idea made us India's first-ever rummy portals.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Wide
                    Range:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">We have over 6+ crore
                      players, making us one of India's largest and most trusted online gaming
                      portals with a variety of games designed to entertain various audiences. All
                      our games can be played by beginners as well as seasoned players.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                    Random Number Generation Certification:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">We earned a
                      certification from iTech Labs for the fair game facility, which is globally
                      accepted.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Feel
                    Supported:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">Excessive gaming can
                      cause you to spend more than you can afford and make you feel anxious or
                      upset when you're not winning. Our resources and customer support help us
                      identify and address problematic behaviours.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Take
                    breaks:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">To avoid burnout, take
                      breaks from gaming. We recommend scheduling gaming times to avoid
                      interfering with daily life.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                    Security and Fair Play:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">We prioritise player
                      safety. Our platform protects your data and ensures fair play with advanced
                      security. Transparency and trust in gaming are our priorities.</p>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">We promote responsible
                      gaming at A23. We strive to keep our platform safe and fun. Enjoy our <a
                        href="https://www.a23.com/rummy/rummy-cash-games.html">online cash
                        games</a> safely by following these responsible gaming practices.</p>
                  </li>
                </ul>
              </div>
              <div><h2 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Why choose
                the A23 online gaming platform?</h2>
                <ul
                  class="list-disc pl-[15px] mb-4 text-[0.75rem] md:text-[14px] sm:text-size-2 md:text-size-2 lg:text-size-3">
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                    Advanced Security:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">We protect players with
                      cutting-edge security protocols. All A23 transactions are protected by
                      2048-bit SSL encryption, protecting personal and financial data.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Fair
                    Play Commitment:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">Our games use a
                      certified Random Number Generator (RNG) to shuffle and deal cards
                      impartially. iTech Labs Australia, a reputable organisation, has certified
                      our RNG. This ensures fair play and impartial results in all our games,
                      boosting player trust.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Fraud
                    Prevention:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">We have several measures
                      in place. Player seating is random, so they cannot predict or control it. We
                      also monitor IP addresses to prevent players from the same location from
                      sharing a table, reducing collusion. Our anti-fraud algorithms monitor every
                      game move to ensure fairness and competition.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                    Internet disconnection:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">For internet outages or
                      disconnections, A23 has a strong framework in place. Disconnected players
                      aren't excluded from the game; the system activates auto-play to protect
                      their interests until they reconnect.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                    Continuous Security:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">Our platform is
                      constantly updated to ensure that our security protocols address new
                      threats. We constantly assess and improve our security to avoid threats.</p>
                  </li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">No
                    Bots:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">A23 doesn't allow bots
                      to make sure only real players play against each other. All players on our
                      platform are verified and have completed KYC, ensuring fairness.</p>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">A23 offers safe and fun
                      online gaming by enforcing strict security and fair play. We have always
                      been committed to player safety and well-being. A23 offers one of the safest
                      online cash gaming experiences.</p></li>
                </ul>
              </div>
              <div><h2 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Getting
                started with A23</h2>
                <ul
                  class="list-disc pl-[15px] mb-4 text-[0.75rem] md:text-[14px] sm:text-size-2 md:text-size-2 lg:text-size-3">
                  <li><a href="https://www.a23.com/rummy/download-rummy.html">Download the A23 app</a>
                    from <a href="https://play.google.com/store/apps/details?id=in.a23.rummy">Google
                      Play</a> or <a
                      href="https://apps.apple.com/in/app/a23-games-rummy-fantasy/id1592656295">Apple
                      App Store</a> to start your journey. Choose from a variety of games to play.
                  </li>
                  <li>Register/Sign Up: Enter the A23 app and tap “sign up.” Enter your phone number
                    and email address.
                  </li>
                  <li>Verify your account: Your mobile number or email address will receive an OTP
                    after registration. You must verify your account with this OTP to increase
                    security and trust.
                  </li>
                  <li>KYC Details: Verify your KYC (know your customer) for a smooth withdrawal and
                    gaming experience. Accessing all gaming app features, including withdrawals and
                    cash games, requires this step. These details will be part of your profile.
                  </li>
                </ul>
              </div>
              <div><h2 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">How does the
                platform work?</h2>
                <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">A23 is an online gaming platform
                  that offers a large selection of games, especially different types of online games .
                  We are constantly looking for new ways to make the games more exciting. Here's how
                  we do it:</p>
                <ul
                  class="list-disc pl-[15px] mb-4 text-[0.75rem] md:text-[14px] sm:text-size-2 md:text-size-2 lg:text-size-3">
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Quick
                    Withdrawals and Deposits:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">We offer lightning-fast
                      withdrawals on our platform for your winnings. You can add money to the
                      wallet and begin playing games that have cash tournaments. So, get playing
                      with the A23 app.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Enjoy
                    bonuses and rewards:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">Start your A23 app
                      journey with a sign-up bonus. We also have free tournaments that help you
                      learn new skills and as well as tutorials to help you learn more about the
                      games.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">Play
                    in a safe environment:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">The platform ensures
                      that all games and gamers are treated fairly with measures to prevent
                      fraud.</p></li>
                </ul>
              </div>
              <div><h2 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">What are the
                different types of games on the A23 app?</h2>
                <ul
                  class="list-disc pl-[15px] mb-4 text-[0.75rem] md:text-[14px] sm:text-size-2 md:text-size-2 lg:text-size-3">
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                    Rummy:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">One of the most popular
                      cash games, it tests players' ability to skillfully win over the players by
                      building win sets and sequences more quickly.</p>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3">A23 has multiple rummy
                      variants, such as Run Rummy, Pool Rummy, and more. <a
                        href="https://www.a23.com/rummy.html">Indian Rummy</a> is the most
                      widely played A23 game, followed by Run Rummy. Each of these games have
                      different rules, and it is important to know them before you enter a
                      tournament. Download the A23 app, improve your skills.</p></li>
                  <li><h3 class="sm:heading-size-2-sm md:heading-size-2-md lg:heading-size-2-lg">
                    Poker:</h3>
                    <p class="sm:text-size-2 md:text-size-2 lg:text-size-3"><a
                      href="https://www.a23.com/poker.html">Poker</a> is one of the most
                      widely played card games, where players place bets based on the cards they
                      have. Each player is dealt a card face down and 5 cards face up that are
                      visible to all the players. You need to use the 2 cards face-down along with
                      the 5 cards face-up to form the strongest hand. At the beginning of the
                      game, each player is given a set number of chips that are used to place
                      their bets. The player with the strongest hand at the end wins all the chips
                      that were placed during the different round. It's all about having a good
                      hand, making smart choices, taking risks, and being strategic enough to stay
                      in the game!</p></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="faqs" class="faqs sm:faqs-sm md:faqs-md lg:faqs-lg xl:faqs-xl">
      <div class="footer-top quicklinks">
        <div class="container">
          <div class="section-title flex">
            <h2
              class="section-heading relative underline-class sm:heading-size-1-sm md:heading-size-1-md lg:heading-size-1-lg">
              FAQs
            </h2>
          </div>
          <div id="faqsDisclosure" class="my-disclosure md:my-disclosure-md">
            <div class="mycontainer">
              <div class="faqs-item sm:faqs-item faqs-item-lastchild faqs-item-lastchild-md">
                <button class="disclosure-button">
                  <h3 class="title text-size-3">
                    {{ getViewText('text_6') }}
                  </h3>
                  <img src="../assets/img/angle-arrow-down.svg" alt="arrow-down" loading="lazy"
                       class="rotate-0 transition duration-300">
                </button>
                <div class="disclosure-inactive">
                  <div class="text-white">
                    <p class="mb-[10px]">
                      {{ getViewText('text_7') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="faqs-item sm:faqs-item faqs-item-lastchild faqs-item-lastchild-md">
                <button class="disclosure-button">
                  <h3 class="title text-size-3">
                    {{ getViewText('text_8') }}
                  </h3>
                  <img src="../assets/img/angle-arrow-down.svg" alt="arrow-down" loading="lazy"
                       class="rotate-0 transition duration-300">
                </button>
                <div class="disclosure-inactive">
                  <div class="text-white">
                    <p class="mb-[10px]">
                      {{getViewText('text_9')}}
                    </p>
                  </div>
                </div>
              </div>

            </div>
            <div class="mycontainer">
              <div class="faqs-item sm:faqs-item faqs-item-lastchild faqs-item-lastchild-md">
                <button class="disclosure-button">
                  <h3 class="title text-size-3">
                    {{getViewText('text_10')}}
                  </h3>
                  <img src="../assets/img/angle-arrow-down.svg" alt="arrow-down" loading="lazy"
                       class="rotate-0 transition duration-300">
                </button>
                <div class="disclosure-inactive">
                  <div class="text-white">
                    <p class="mb-[10px]">
                      {{getViewText('text_11')}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="faqs-item sm:faqs-item faqs-item-lastchild faqs-item-lastchild-md">
                <button class="disclosure-button">
                  <h3 class="title text-size-3">
                    {{ getViewText('text_12') }}
                  </h3>
                  <img src="../assets/img/angle-arrow-down.svg" alt="arrow-down" loading="lazy"
                       class="rotate-0 transition duration-300">
                </button>
                <div class="disclosure-inactive">
                  <div class="text-white">
                    <p class="mb-[10px]">
                      {{ getViewText('text_13')}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footBox/>

  </div>
</template>


<!--
<script>
import { VueSlickCarousel } from 'vue-slick-carousel'
// 导入样式
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// 可选：导入主题
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


export default {
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      settings1: {
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      },
      settings2: {
        autoplay: false, // 不自动播放
        dots: false,     // 不显示点导航
        arrows: true,    // 显示箭头
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    };
  }
}
</script> -->

<style scoped>

.slider1 {
  background: #032146;
}

.slider1 .img_box img {
  width: 100% !important;
  margin: 0 auto;
  /* object-fit: cover; */
  padding: 0;
  margin: 0;
}

.slider2 {
  height: 365px;
}

.slider2 .img_box {
  height: 325px;
}

.slider3 {
  height: auto;
}

.slider3 .img_box {
  width: 100%;
  height: 189px;
  background: url("../assets/img/gamersBG.png") no-repeat;
  background-size: 100%;
  display: flex !important;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 20px 20px;
}

.slider3 .img_box img {
  height: 50%;
}

.slider3 .img_box .px-2 {
  height: fit-content;
  line-height: 1;
}

</style>



// WEBPACK FOOTER //
// src/views/index.vue